import resetMailRibbonConfiguration from "../actions/resetMailRibbonConfiguration";
import { getStore } from "../store/store";
import loadMailRibbonConfigurationForAccount from "../util/loadMailRibbonConfigurationForAccount";
import { getMailboxInfoByAccountKey } from "owa-account-source-list-store";
import onWin32StyleEnabledChanged from "owa-theme-win32-style-store/lib/actions/onWin32StyleEnabledChanged";
import { orchestrator } from "satcheljs";

orchestrator(onWin32StyleEnabledChanged, () => {
    for (const accountKey of getStore().entries.keys()) {
        const mailboxInfo = getMailboxInfoByAccountKey(accountKey);
        if (mailboxInfo) {
            resetMailRibbonConfiguration(accountKey);
            void loadMailRibbonConfigurationForAccount(mailboxInfo);
        }
    }
});
